import { HttpParams } from '@angular/common/http';
import { forwardRef, Inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ACTION_DEFINITIONS_V2 } from '../common/endpoints';
import { ActionDefinition, PagedList } from '../model';
import { AuthenticationService } from './authentication.service';
import { HttpService } from './http.service';


@Injectable()
export class ActionDefinitionService {

    constructor(
        @Inject(forwardRef(() => HttpService)) private http: HttpService,
        @Inject(forwardRef(() => AuthenticationService)) private authenticationService: AuthenticationService
    ) { }


    getRecursivelyAll(page?: number, actionDefinitions?: ActionDefinition[], params?: HttpParams, sort?: string[]): Promise<ActionDefinition[]> {
        if (!page) {
            page = 0;
        }
        if (!actionDefinitions) {
            actionDefinitions = [];
        }
        if (!sort) {
            sort = ['name', 'asc'];
        }
        return this.getPagedActionDefinitions(page, 200, sort, params)
            .then(pagedDefs => {
                actionDefinitions = actionDefinitions.concat(pagedDefs.content);
                if (pagedDefs.last) {
                    return actionDefinitions;
                } else {
                    return this.getRecursivelyAll(++page, actionDefinitions, params, sort);
                }
            });
    }

    getPagedActionDefinitions(page: number, size: number, sort: string[], params?: HttpParams): Promise<PagedList<ActionDefinition>> {
        if (!params) {
            params = new HttpParams();
        }
        params = params.set('page', page + '');
        params = params.set('size', size + '');
        if (sort) {
            params = params.set('sort', sort.join(','));
        }
        params = params.set('language', this.authenticationService.getUser()?.language || navigator.language);
        return firstValueFrom(this.http.get<PagedList<ActionDefinition>>(ACTION_DEFINITIONS_V2, params));
    }

}